export default __webpack_public_path__ + "static/media/Cover-Idea.7771ed93.jpg";